import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

//Custom Components

import VideoSingle from './videoSingle';
import Audioslider from './audioslider';

import Iconset from './icons';
import VideoDOM from './videoDOM';
import Preorder from './preorder';

//styles
import '../styles/transition-group.scss';
import '../styles/transition-scale.scss';

class LiveSession extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			
			videoIsPlaying : false,
			volumeHasChanged : false,
			hasToggled : false,
			showAudio:false,
			activeVideo : 0,
			readyCount : 0,
			ready : false,
			intro : true,
			audioEndTime :285,
			audioIsReady : false,
			videoIsReady : false,
			bookSession : false,
			bookTime : 0,
			bookActive : false,
			bookInLoop : true,
			bookWasAlreadyVisible : false,
			bookIsInCloseMode : false,
			bookLoopStart : 6,
			bookLoopEnd : 16,
			bookSessionStartTime : 40,//in seconds
			spur :{ 
				Bass: {
					name : 'Bass',
					value : .75,
					videoElement : null 
				},
				Drums : {
					name : 'Drums',
					value : .7,
					videoElement : null
				},
				Guitar : {
					name : 'Guitar',
					value : .9,
					videoElement : null
				},
				Vocals : {
					name : 'Vocals',
					value : .8,
					videoElement : null
				}
			}
		}

		this.addHandler();

		this.skip = this.skip.bind(this);
		this.openBookVideo = this.openBookVideo.bind(this);
		this.closeBookVideo = this.closeBookVideo.bind(this);
		this.booksUpdateVideoTime = this.booksUpdateVideoTime.bind(this);
		this.booksEnded = this.booksEnded.bind(this);

		this.changeVol = this.changeVol.bind(this);
	}

	componentDidMount(){

		console.log('livesession did mount', this.props.isPlaying);
		

		var newState = {
		    ...this.state,
		    spur: {
		        ...this.state.spur,
		        Vocals: {
				        ...this.state.spur.Vocals,
				        videoElement : this.refs.totaleVideo
				    },
				    Guitar: {
				        ...this.state.spur.Guitar,
				        videoElement : this.refs.guitarVideo
				    },
				    Bass: {
				        ...this.state.spur.Bass,
				        videoElement : this.refs.bassVideo
				    },
				    Drums: {
				        ...this.state.spur.Drums,
				        videoElement : this.refs.drumsVideo
				    },
		    },
		};

		this.setState(newState,function(){
			this.props.mainPlay();	
			// if(this.props.isPlaying){
			// 	console.log('isPlaying');
			// 	this.promisePlay();
			// 	// let playPromise = this.play();
			// 	// console.log(playPromise);
			// 	// if(typeof playPromise != 'undefined'){
			// 	// 	playPromise.then(function(){
			// 	// 		console.log('play promise success');
			// 	// 		this.pause();

			// 	// 		this.play();
			// 	// 	}.bind(this));
			// 	// }else{
			// 	// 	this.play();
			// 	// }
			// }else{
			// 	this.props.mainPlay();	
			// }
		});
	}

	promisePlay(){
		let playPromises = this.play();
		console.log(playPromises);
		if(typeof playPromise != 'undefined'){
			 Promise.all(playPromises).then(function(){
				console.log('play promise success');
				this.pause();

				this.play();
			}.bind(this));
		}else{
			this.play();
		}
	}

	componentWillUnmount(){
 		this.removeHandler();
 	}

	checkReadyState(){
		if(this.state.videoIsReady){
			this.setState({
				ready : true
			});
		}
	}

	play(cb){
			
		var playPromise1 = this.refs.totaleVideo.playVideo();
		var playPromise2 = this.refs.guitarVideo.playVideo();
		var playPromise3 = this.refs.drumsVideo.playVideo();
		var playPromise4 = this.refs.bassVideo.playVideo();

		let timeCode = this.props.timecode.toFixed(2);

		if( parseFloat( timeCode) == 0){
			timeCode = 0.01;
		}
		if(_assets.isSafari){
			setTimeout(function(){
				console.log('reset for safari');
				let timeCode = this.props.timecode.toFixed(2);
				this.refs.totaleVideo.refs.video.currentTime = timeCode;//;this.props.timecode;
				this.refs.guitarVideo.refs.video.currentTime = timeCode;//;this.props.timecode;
				this.refs.drumsVideo.refs.video.currentTime = timeCode;//; this.props.timecode;
				this.refs.bassVideo.refs.video.currentTime = timeCode;//; this.props.timecode;
			}.bind(this),3000);
		}

		this.refs.totaleVideo.refs.video.currentTime = timeCode;//;this.props.timecode;
		this.refs.guitarVideo.refs.video.currentTime = timeCode;//;this.props.timecode;
		this.refs.drumsVideo.refs.video.currentTime = timeCode;//; this.props.timecode;
		this.refs.bassVideo.refs.video.currentTime = timeCode;//; this.props.timecode;
		
		
		//only when booksession is active
		if(this.state.bookActive){
			this.refs.videoBook.playVideo();
		}

		if(typeof cb != "undefined"){
			cb();
		}

		return [playPromise1,playPromise2,playPromise3,playPromise4];

	}

	pause(cb){
			this.refs.totaleVideo.pauseVideo();
			this.refs.guitarVideo.pauseVideo();
			this.refs.drumsVideo.pauseVideo();
			this.refs.bassVideo.pauseVideo();

			console.log(this.props.timecode, this.refs.totaleVideo.refs.video.currentTime);
			//only when booksession is active
			if(this.state.bookActive){
				this.refs.videoBook.pauseVideo();
			}

			if(typeof cb != "undefined"){
				cb();
			}
	}

	//fire play from outside(main timeline)
	componentWillReceiveProps(nextProps){
		if(this.props.timecode > this.state.bookSessionStartTime && !this.state.bookSession && !this.state.bookWasAlreadyVisible){
			this.setState({
				bookSession : true
			})
		}

		if(this.props.timecode > 6){
			this.setState({
				showAudio : true
			})
		}

		if(nextProps.isPlaying != this.state.videoIsPlaying){
			//console.log(this.state.videoIsPlaying, nextProps.isPlaying)
				
			this.setState({
				videoIsPlaying : nextProps.isPlaying
			},function(){
				if(nextProps.isPlaying){
					//this.play();
					this.promisePlay();
				}else{
					this.pause();
				}
			});	
		}
	}

	toggleVideo(){
		if(this.props.isPlaying){
			let currentVid = this.state.activeVideo;
			currentVid = currentVid < 3 ? (currentVid+=1) : 0;
			this.setState({
				activeVideo : currentVid,
				hasToggled : true
			});
		}
	}

	keyBoardHandler(event){
		if(event.keyCode == 32){
			event.target.blur();
			this.toggleVideo();
		}
	}

	touchHandler(event){
		this.toggleVideo();
	}

  addHandler(){
  	this.keyBoardHandlerAction = (event) => this.keyBoardHandler(event);
  	this.touchHandlerAction = (event) => this.keyBoardHandler(event);
  	
  	window.addEventListener('keydown', this.keyBoardHandlerAction ,false);
  	window.addEventListener('touchstart', this.touchHandlerAction ,false);
  }
	
	removeHandler(){
		window.removeEventListener('keydown', this.keyBoardHandlerAction);
		window.removeEventListener('touchstart', this.touchHandlerAction);
	}
	
	changeSpurVolume(name,value){

		let slideVol = Object.assign( this.state.spur[name], {
			value: value 
		});
			
		this.setState(slideVol);
		this.state.spur[name].videoElement.changeVolume(value);
	}

	changeVol(event){
		if(this.props.isPlaying){
			let volume = parseFloat(event.target.value);
			let name = event.target.name;
			this.setState({
				volumeHasChanged : true
			});
			this.changeSpurVolume(name,volume);
		}
	}

	resetVolume(){

		this.changeSpurVolume('Bass', .75);
		this.changeSpurVolume('Drums',  .7);
		this.changeSpurVolume('Guitar', .9);
		this.changeSpurVolume('Vocals',  .8);
		this.setState({
			volumeHasChanged : false
		});

	}

	toggleBookVideo(){

		if(!this.state.bookActive){
			this.setState({
				bookActive : true
			});
			
		}else{

			this.refs.videoBook.refs.video.currentTime = this.state.bookLoopEnd;
			this.setState({
				bookInLoop : false,
			})
		}
	}


	openBookVideo(){
		this.setState({
			bookActive : true,
			bookSession : true,
			bookIsInCloseMode : false
		});
	}

	closeBookVideo(){
		this.refs.videoBook.refs.video.currentTime = this.state.bookLoopEnd;
			this.setState({
				bookInLoop : false,
				bookIsInCloseMode : true
		});
	}

	booksEnded(){
		this.setState({
			bookActive : false,
			bookSession: false,
			bookWasAlreadyVisible : true,
		});
	}

	booksUpdateVideoTime(video){
		if(Math.floor(video.currentTime).toFixed(0) == this.state.bookLoopEnd && this.state.bookInLoop){
			video.currentTime = this.state.bookLoopStart;
			console.log('loop');
		}
	}

	skip(){

		this.refs.totaleVideo.seekTo(293);
		this.refs.guitarVideo.seekTo(293);
		this.refs.drumsVideo.seekTo(293);
		this.refs.bassVideo.seekTo(293);

	}

	render(){
		return (
			<main className="live-session-holder">

		{/* Tooltip Session */}
				<ReactCSSTransitionGroup
					component= "div"
					className="preorder-holder"
			    transitionName="fade"
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>
						<Preorder />
					</ReactCSSTransitionGroup>
					
		{/* Tooltip Session */}
			<ReactCSSTransitionGroup
					component= "div"
					className="main-tooltip-holder"
			    transitionName="fade"
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>
					{ (this.props.timecode > 6 && this.props.timecode < this.state.audioEndTime) && (!this.state.bookActive) && 
					 	<div className="main-tooltip">
					 		<Iconset.loader />

					 	{/* meeh */}
					 		{ (this.props.timecode>6 && !this.state.hasToggled) &&
					 			<span className="isVisible">Press space to interact</span>
					 		}
					 		{this.state.hasToggled &&
					 			<span>Press space to interact</span>
					 		}

					 	</div>
					}
				</ReactCSSTransitionGroup>

			{/* Audio Element Session */}
				<div className="audio-element">
					<div className="audio-element-inner">
						<div className="audio-element-range-slider">
								<ReactCSSTransitionGroup
									component= "div"
									className="audio-slider-holder"
				          transitionName="fade"
				          transitionAppear={true}
	     						transitionAppearTimeout={500}
				          transitionEnterTimeout={500}
				          transitionLeaveTimeout={300}>
				      			{ this.state.showAudio && this.props.timecode > 6 && this.props.timecode < this.state.audioEndTime && !this.state.bookActive && 
						      		<div className="audio-slider-panel">
						      			<div className="audio-slider-inner" key="audioslider">
						      			
													<Audioslider value={this.state.spur['Guitar'].value} name={'Guitar'} onChange={ this.changeVol }/>
													<Audioslider value={this.state.spur['Vocals'].value} name={'Vocals'} onChange={ this.changeVol }/>
													<Audioslider value={this.state.spur['Drums'].value} name={'Drums'} onChange={ this.changeVol }/>
													<Audioslider value={this.state.spur['Bass'].value} name={'Bass'} onChange={ this.changeVol }/>
													
												</div>
												<button className={"resetAudioVolume hasChanged-" + this.state.volumeHasChanged} onClick={this.resetVolume.bind(this)}>Reset Volume</button>
											</div>
									}
							</ReactCSSTransitionGroup>
						</div>
					</div>
				</div>

			{/* Book Session */}
				<div className="live-session video-element">
					<div className={'video-element-inner active-video-'+ this.state.activeVideo} >
						{/*<ReactCSSTransitionGroup
							component= "div"
							className="absolute inner-intro-session"
				      transitionName="fade"
				      transitionAppear={true}
	     				transitionAppearTimeout={500}
				      transitionEnterTimeout={500}
				      transitionLeaveTimeout={300}>
				      {this.state.intro && this.props.timecode > 0 && this.props.timecode < 5 &&
				      	<div className="inner-note-session">
				      		<h1>livesession</h1>
				      	</div>
				      }
				      </ReactCSSTransitionGroup>	*/}

						<ReactCSSTransitionGroup
							component= "div"
							className="book-session"
				      transitionName="fade"
				      transitionAppear={true}
	     				transitionAppearTimeout={500}
				      transitionEnterTimeout={500}
				      transitionLeaveTimeout={300}>
								
									<div className="book-session-holder">
										{!this.state.bookActive && this.state.activeVideo == 0 && this.props.timecode < this.state.audioEndTime &&
											<button className={"book-toggler book-visible-" + this.state.bookWasAlreadyVisible + " book-active-" + this.state.bookSession  } onClick={ this.openBookVideo }><Iconset.openBook /></button>
										}
										<ReactCSSTransitionGroup
											component= "div"
											className="book-session-video"
										  transitionName="scale"
										  transitionAppear={true}
								    	transitionAppearTimeout={500}
										  transitionEnterTimeout={500}
										  transitionLeaveTimeout={300}>
									     	{this.state.bookActive && this.state.bookSession &&
									     	<div className="book-session-video-inner">
									     	{!this.state.bookIsInCloseMode && 
									     		<button className="close-book-session" onClick={ this.closeBookVideo }><Iconset.close /></button>
												}
													<VideoDOM 
														src={_assets.loaded.bookVideo} 
														timeupdate ={ this.booksUpdateVideoTime }
														ended ={ this.booksEnded }
														name="video-book"
														ref="videoBook"
														groupName="book"
														autoPlay="true" />
												</div>
											}
										</ReactCSSTransitionGroup>
									</div>
							</ReactCSSTransitionGroup>

					{/* Video Session */}	

					<VideoDOM 
							src={_assets.loaded.totaleVideo} 
							timeupdate ={this.props.timeupdate}
							ended={this.props.ended}
							name="video-0"
							ref="totaleVideo"
							groupName="session"/>
					<VideoDOM 
							src={_assets.loaded.guitarVideo} 
							timeupdate ={this.props.timeupdate}
							name="video-1"
							ref="guitarVideo"
							groupName="session"/>
					<VideoDOM 
							src={_assets.loaded.drumsVideo} 
							timeupdate ={this.props.timeupdate}
							name="video-2"
							ref="drumsVideo"
							groupName="session"/>
					<VideoDOM 
							src={_assets.loaded.bassVideo} 
							timeupdate ={this.props.timeupdate}
							name="video-3"
							ref="bassVideo"
							groupName="session"/>
					</div>
				</div>
			</main>
			);
	}
}


export default LiveSession;


// WEBPACK FOOTER //
// ./src/scripts/livesession.js